<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card style="min-width: 600px">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Connect Power Source</div>
        <q-space />
        <q-btn v-close-popup icon="close" flat round dense />
      </q-card-section>

      <q-form @submit="onSubmit">
        <q-card-section>
          <div class="text-subtitle2 q-mb-md">
            Equipment: <strong>{{ formData.equipment_name }}</strong>
          </div>

          <q-select
            :model-value="formData.power_source_id"
            label="Power Source *"
            filled
            :options="availablePowerSources.map(p => ({
              label: `${p.name} (${p.source_type})`,
              value: p.id,
              source: p
            }))"
            emit-value
            map-options
            :rules="[val => !!val || 'Power Source is required']"
            class="q-mb-md"
            @update:model-value="emit('update:power-source-id', $event)"
          >
            <template #option="scope">
              <q-item v-bind="scope.itemProps">
                <q-item-section>
                  <q-item-label>{{ scope.opt.source.name }}</q-item-label>
                  <q-item-label caption>
                    Type: {{ scope.opt.source.brick_class?.replace('brick:', '') || scope.opt.source.source_type }}
                  </q-item-label>
                </q-item-section>
                <q-item-section side>
                  <q-badge :color="scope.opt.source.source_type === 'MSB' ? 'red' : scope.opt.source.source_type === 'MSSB' ? 'orange' : 'blue'">
                    {{ scope.opt.source.source_type }}
                  </q-badge>
                </q-item-section>
              </q-item>
            </template>
          </q-select>

          <q-banner class="bg-grey-3 rounded-borders">
            <template #avatar>
              <q-icon name="info" color="primary" />
            </template>
            <div class="text-caption">
              <strong>BRICK Validation Rules:</strong><br/>
              • DDC Panels must be fed by MSSB or DB (never MSB)<br/>
              • MSSB can be fed by MSB or another MSSB<br/>
              • Other equipment can be fed by MSB, MSSB, or DB
            </div>
          </q-banner>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn v-close-popup flat label="Cancel" color="grey" />
          <q-btn unelevated label="Connect" type="submit" color="primary" :loading="saving" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    availablePowerSources: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:power-source-id',
    'submit',
  ]);

  function onSubmit() {
    emit('submit');
  }
</script>
